import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {marketRegister} from "../../services/marketRegister";
import {campaignRegister} from "../../services/campaignRegister";
import Countdown from "../../components/countdown/component";
import {dataRegister} from "../../services/dataRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class UserBillingInvoicesItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            invoice: null
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        try {
            this.setState({id: this.props.match.params.id}, () => {
                this._updateData();
            });
        }catch (e) {}
    }

    _updateData() {
        dataRegister.invoice(salesChannelRegister.get("market"), this.state.id).then((response) => {
            console.log(response);
            if(!response.errors){
                this.setState({invoice: response});
            }
        }, (error) => {});
    }

    _signOut() {
        userRegister.remove();
        tokenRegister.remove();
        this.props.history.push("/");
    }

    _renderPartialBudget() {
        if (this.state.channels) {
            let budget = 0;
            for (let key in this.state.channels) {
                budget = budget + this.state.channels[key];
            }
            if (this.state.lockin) {
                budget = budget + (this.state.plan_price * (marketRegister.lockin() - marketRegister.discount()));
            } else {
                budget = budget + this.state.plan_price;
            }
            return budget;
        } else {
            return ("...");
        }
    }

    _renderChannel(channel){
        if(channel === "fb"){
            return "facebook"
        }else{
            return channel;
        }
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return (0)
        }
    }

    _renderText(item) {
        return langRegister.get("user-billing-receipts-item", item);
    }

    render() {
        return (
            <div className={Styles.view}>
                    <div className={Styles.contentHeader}>
                        <div className={Styles.contentHeaderTitle}/>
                        <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                            {this._renderText("item_4")}
                        </div>
                    </div>
                {
                    this.state.invoice &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <span className={Styles.titleBold}>{this._renderText("item_1")}</span>&nbsp;<span className={Styles.titleBoldGreen}>{this._renderText("item_2")}</span>
                        </div>
                        <div className={Styles.campaignId}>
                            {this._renderText("item_3")} <span className={Styles.campaignIdNumber}>#{this.state.invoice.stripe_charge_id}</span>
                        </div>
                        <div className={Styles.divider}/>
                        <div onClick={() => this._myAccount()} className={cx(Styles.button, Styles.buttonBlack)}>
                            {this._renderText("item_11")}
                        </div>
                        <div className={Styles.button}>
                            {this._renderText("item_12")}
                        </div>
                        <div className={Styles.divider}/>
                        <div className={Styles.contentContainerItem}>
                            <div className={Styles.contentContainerItemUpper}>
                                <div className={Styles.contentContainerItemUpperLeft}>
                                    {this._renderText("item_19")}
                                </div>
                                <div className={Styles.contentContainerItemUpperRight}>
                                    {this.state.invoice.duration}&nbsp;{this._renderText("item_20")}
                                </div>
                            </div>
                        </div>
                        <div className={Styles.dividerSmall}/>
                        <div className={Styles.contentContainer}>
                            {
                                Object.keys(this.state.invoice.channel_spend).map((key, i) => {
                                    return(
                                        <div key={i} className={Styles.contentContainerItem}>
                                            <div className={Styles.contentContainerItemUpper}>
                                                <div className={Styles.contentContainerItemUpperLeft}>
                                                    {this._renderChannel(key).toUpperCase()}
                                                </div>
                                                <div className={Styles.contentContainerItemUpperRight}>
                                                    {this._renderNumbers(this.state.invoice.channel_spend[key])}&nbsp;{this.state.invoice.currency.toUpperCase()}
                                                </div>
                                            </div>
                                            <div className={Styles.contentContainerItemLower}>
                                                <div className={Styles.contentContainerItemLowerLeft}>
                                                    {Math.floor(this.state.invoice.channel_spend[key] / this.state.invoice.duration)}&nbsp;{this.state.invoice.currency.toLowerCase()}&nbsp;/&nbsp;{this._renderText("item_21")}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }

                            <div className={Styles.contentContainerItem}>
                                <div className={Styles.contentContainerItemUpper}>
                                    <div className={Styles.contentContainerItemUpperLeft}>
                                        {this._renderText("item_15").toUpperCase()}
                                    </div>
                                    {
                                        !this.state.lockin && false &&
                                        <div className={Styles.contentContainerItemUpperRight}>
                                            {this.state.plan_price}&nbsp;{this.state.currency.toUpperCase()}
                                        </div>
                                    }
                                    {
                                        this.state.lockin && false &&
                                        <div className={Styles.contentContainerItemUpperRight}>
                                            {this.state.plan_price * (marketRegister.lockin() - marketRegister.discount())}&nbsp;{this.state.currency.toUpperCase()}
                                        </div>
                                    }
                                </div>
                                <div className={Styles.contentContainerItemLower}>
                                    <div className={Styles.contentContainerItemLowerLeftService}>

                                    </div>
                                    <div className={Styles.contentContainerItemLowerRightService}>
                                        {
                                            this.state.lockin && false &&
                                            <span>-{marketRegister.discount() * this.state.plan_price} {marketRegister.currency()}</span>
                                        }
                                    </div>
                                </div>
                            </div>

                            {
                                this.state.landingpage && false &&
                                <div className={Styles.contentContainerItem}>
                                    <div className={Styles.contentContainerItemUpper}>
                                        <div className={Styles.contentContainerItemUpperLeft}>
                                            {this._renderText("item_23")}
                                        </div>
                                        <div className={Styles.contentContainerItemUpperRight}>
                                            0&nbsp;{this.state.invoice.currency}
                                        </div>
                                    </div>
                                    <div className={Styles.contentContainerItemLower}>
                                        <div className={Styles.contentContainerItemLowerLeftService}>
                                            www.1231231.adbop.com
                                        </div>
                                    </div>
                                </div>
                            }

                        </div>
                        <div className={Styles.dividerSmall}/>
                        <div className={Styles.vatContainer}>
                            <div className={Styles.vatContainerLeft}>
                                {this._renderText("item_17")}&nbsp;({this.state.invoice.vat}%)
                            </div>
                            <div className={Styles.vatContainerRight}>
                                {this._renderNumbers(this._renderPartialBudget() * (this.state.invoice.vat / 100))}&nbsp;{this.state.invoice.currency.toUpperCase()}
                            </div>
                        </div>
                        <div className={Styles.dividerSmall}/>
                        <div className={Styles.totalContainer}>
                            <div className={Styles.totalContainerLeft}>
                                {this._renderText("item_18")}
                            </div>
                            <div className={Styles.totalContainerRight}>
                                {this._renderNumbers(this._renderPartialBudget() * ((this.state.invoice.vat / 100) + 1))}&nbsp;{this.state.invoice.currency.toUpperCase()}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default UserBillingInvoicesItem;


// WEBPACK FOOTER //
// ./src/components/user-billing-invoices-item/component.js